var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMe = function SvgMe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c7f33545-e8a0-4158-bf58-89ddbc57d879a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D4AF2C",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "6da88afb-269d-46a8-a33d-dc1b242aa642b",
    width: 19,
    height: 13,
    x: 1,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 1H2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h17a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#6da88afb-269d-46a8-a33d-dc1b242aa642b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C60000",
    d: "M19 1H2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h17a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5B02B",
    fillRule: "evenodd",
    d: "M10.5 4.778 9.333 4l-.777.778h.777l-.777.778L7 4.778v3.89l2.333-.78-.777 1.556h-.778l.778.778.777-.778L10.5 11zM11.667 4l.777.778h-.777l.777.778L14 4.778v3.89l-2.333-.78.777 1.556h.778l-.778.778-.777-.778L10.5 11V4.778z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185D93",
    fillRule: "evenodd",
    d: "M9 6.505a1.5 1.5 0 1 1 3 0v-.343c0 .83-.508 1.956-1.12 2.502L10.5 9l-.38-.336C9.503 8.114 9 6.994 9 6.162z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C58724",
    fillRule: "evenodd",
    d: "M9 6h3v1H9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c7f33545-e8a0-4158-bf58-89ddbc57d879a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgMe;